import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Manual from "../Manuals/Manual";
import {useTecRmi} from "../../../contexts/TecRmiContext";
import TreeMenuNew from "../../../componentsReusable/TreeMenuNew/TreeMenuNew";
import Breadcrumb from "../../Breadcrumb";
import PrintButton from "../PrintButton";

const LinkedTechnicalManuals = props => {
  const { typeId } = useTecRmi()
  const [crumbs, setCrumbs] = useState([])

  const getMappedItems = () => {
    return props.manuals.map(item => ({
      id: item.ItemMpId,
      key: `item-${item.ItemMpId}`,
      path: props.pathPrefix + '/' + item.ItemMpId,
      label: item.ItemMpText,
      items: item.Manuals.map(manual => ({
        id: manual.ManualId,
        key: `manual-${manual.ManualId}`,
        path: props.pathPrefix + '/' + [item.ItemMpId, manual.ManualId].join('/'),
        label: manual.QualColText,
        component: Manual,
        componentProps: {
          typeId,
          manualId: manual.ManualId,
        }
      }))
    }))
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center flex-wrap">
        <Breadcrumb
          crumbs={[
            {
              name: <i className="fas fa-home" />,
              path: props.pathPrefix,
            },
            ...crumbs
          ]}
        />

        <div className="d-flex flex-row flex-nowrap align-items-center justify-content-end ml-auto">
          <PrintButton />
        </div>
      </div>
      <TreeMenuNew
        actives={props.params}
        items={getMappedItems()}
        onCrumbsChanged={setCrumbs}
      />
    </div>
  );
};

LinkedTechnicalManuals.propTypes = {
  manuals: PropTypes.array.isRequired,
};

export default LinkedTechnicalManuals;